<template>
  <div class="tkscenicApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="cont">
      <div class="info">
        <h2>{{setDetail.title}}</h2>
        <div class="js" v-html="setDetail.content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/crowdinfo',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .tkscenicApp{
    background:#fff;
  }
  .tkscenicApp .cont{
    width:100%;
    display:block;
    margin:0 auto;
    background: #FFFFFF;
    z-index:99;
  }
  

  .tkscenicApp .info{
    background:#fff;
    width:100%;
    display:block;
  }
  .tkscenicApp .info h2{
    font-size:16px;
    padding-top:15px;
    width:92%;
    display:block;
    margin:0 auto;
  }
  .tkscenicApp .info .js{
    width:92%;
    display:block;
    margin:0 auto;
    line-height:24px;
    letter-spacing:1px;
    color:#666;
    font-size:15px;
  }
  .tkscenicApp .info .js img{
    display:block;
    width:100%
  }
</style>